<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Rental Agreement Value Item</h4>
  <button type="button" class="btn-close bg-secondary" aria-label="Close" (click)="dismiss()"></button>
</div>
@if (vm$ | async; as vm) {
  <div class="modal-body d-flex flex-column">
    <form
      id="6ba94a1a-7a43-4ccd-bf88-498c6f861bfc"
      class="d-flex flex-fill flex-column"
      [formGroup]="form"
      (ngSubmit)="submit()">
      <div class="row align-items-center g-1">
        <div class="col-sm-6">
          <div class="form-floating">
            <select class="form-select validated" id="itemType" formControlName="itemType">
              @for (option of getItemTypeOptions(); track $index) {
                <option [value]="option.value">{{ option.name }}</option>
              }
            </select>
            <label for="itemType">Type</label>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-floating">
            <select class="form-select validated" id="code" formControlName="code">
              @for (availableValue of availableValues; track availableValue.uid) {
                <option [value]="availableValue.code">{{ availableValue.code.toUpperCase() }}</option>
              }
            </select>
            <label for="code">Code</label>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-floating">
            <input
              type="number"
              class="form-control validated"
              id="amountWithoutTax"
              formControlName="amountWithoutTax" />
            <label for="amountWithoutTax">Amount Without Tax</label>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-floating">
            <input type="number" class="form-control validated" id="taxRate" formControlName="taxRate" />
            <label for="taxRate">Tax Rate</label>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-floating">
            <input type="number" class="form-control validated" id="excess" formControlName="excess" />
            <label for="excess">Excess</label>
          </div>
        </div>
        @if (form.controls.code.value.toLowerCase() === 'dayvalue') {
          <div class="col-sm-6">
            <div class="form-floating">
              <input type="number" class="form-control validated" id="quantity" formControlName="quantity" />
              <label for="quantity">Quantity (Days)</label>
            </div>
          </div>
        }
        <div class="col-sm-12"></div>
        <div class="col-sm-6">
          <div class="bg-100 rounded p-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="isByRental" formControlName="isByRental" />
              <label class="form-check-label fs-7" for="isByRental">Is By Rental</label>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="bg-100 rounded p-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="isIncluded" formControlName="isIncluded" />
              <label class="form-check-label fs-7" for="isIncluded">Is Included</label>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="bg-100 rounded p-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="isSoldByBroker" formControlName="isSoldByBroker" />
              <label class="form-check-label fs-7" for="isSoldByBroker">Is Sold By Broker</label>
            </div>
          </div>
        </div>
      </div>
      @if (errors) {
        <div class="row align-items-center g-1 pt-1 m-1">
          <div class="col-12">
            <div class="alert alert-danger m-0">
              @for (error of errors; track $index) {
                <div class="text-center">{{ error }}</div>
              }
            </div>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    @if (!isReadonly()) {
      <button
        type="submit"
        form="6ba94a1a-7a43-4ccd-bf88-498c6f861bfc"
        class="btn btn-success"
        [disabled]="!form.valid || !form.dirty">
        <div class="d-flex justify-content-center align-items-center gap-2">
          <div>
            <i class="fa-solid fa-save fa-fw"></i>
          </div>
          <div>Confirm</div>
        </div>
      </button>
    }
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Close</button>
  </div>
} @else {
  <div class="modal-body">
    <app-loader />
  </div>
}
